/**
 * Active currency helpers.
 */
import { getConfig, getSettings } from '../config.js';

export function activeCurrency() {
	const config = getConfig();
	if (config.currency) {
		return String(config.currency);
	}
	const settings = getSettings();
	return (settings.config && settings.config.currency) || 'GBP';
}

export function activeLanguage() {
	const config = getConfig();
	if (config.language) {
		return String(config.language);
	}
	const settings = getSettings();
	return (settings.config && settings.config.language) || '';
}

export function cacheKey(productId, currency = activeCurrency(), language = activeLanguage()) {
	const lang = language ? String(language) : 'default';
	return `${currency}:${lang}:${productId}`;
}
